import React, { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { TextField, Button, IconButton, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { TEAL } from "../constants";

const LineSearchBar = forwardRef(function LineSearchBar({ onApply, onClear }, ref) {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => setInputValue(""),
  }));

  const handleApply = () => {
    if (inputValue.trim()) onApply(inputValue.trim());
  };

  const handleClear = () => {
    setInputValue("");
    onClear();
    inputRef.current?.focus();
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <TextField
        inputRef={inputRef}
        size="small"
        placeholder="Cari reportingline..."
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleApply();
          if (e.key === "Escape") handleClear();
        }}
        sx={{
          width: 210,
          "& .MuiInputBase-root": { fontSize: 12, height: 34, pr: 0.5 },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ddd" },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 15, color: "#bbb" }} />
            </InputAdornment>
          ),
          endAdornment: inputValue ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClear} sx={{ p: 0.3 }}>
                <CloseIcon sx={{ fontSize: 13, color: "#bbb" }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      <Button
        variant="contained"
        disableRipple
        disableElevation
        startIcon={<SearchIcon sx={{ fontSize: 14 }} />}
        onClick={handleApply}
        sx={{
          height: 34, fontSize: 12, textTransform: "none",
          backgroundColor: TEAL, borderRadius: 1.5, px: 2,
          whiteSpace: "nowrap",
          "&:hover": { backgroundColor: "#0a6b58" },
        }}
      >
        Cari
      </Button>
    </div>
  );
});

export default LineSearchBar;